/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { fetchListRegions, resetRegion } from '../../../modules/sport/actions/reducerListRegion';
import { getCommuneByRegions } from '../../../modules/sport/actions/reducerListCommune';
import goToPositions from '../../../common/components/images/challenges/go-to-challenge.png';
import DesafiaIconsFutbol from '../../../common/components/images/sports/futbol/icons/desafia2@2x.png';

import Image from '../../Image';
export default function FilterDefy(props: { dateList: any; filter; setFilter; handlerPositions }): JSX.Element {
    const { dateList, filter, setFilter, handlerPositions } = props;
    const [loading] = useState<boolean>(false);
    const errorInit = { region: false, commune: false };
    const [error] = useState(errorInit);
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const [communes, setCommune] = useState<Array<any>>([]);
    const dispatch = useDispatch();

    const selectListCommunes = (state: any) => state.listCommunes;
    const listCommunes = useSelector(selectListCommunes);

    useEffect(() => {
        dispatch(getCommuneByRegions({ id: filter.region, sport: sport, filter: 1, type: 'challenge' }));
    }, []);

    useEffect(() => {
        if (listCommunes && listCommunes.data?.data?.length > 0) {
            setCommune(listCommunes.data?.data);
        } else {
            setCommune([]);
        }
    }, [listCommunes]);

    useEffect(() => {
        setCommune([]);
        dispatch(resetRegion());
        dispatch(fetchListRegions({ filter: 1, sport: sport }));
    }, [sport]);

    const handleWeek = (e) => {
        e.preventDefault();
        let week = null;
        if (e.target.value !== '') {
            week = dateList.find((item) => item.id === e.target.value);
        }

        setFilter({
            ...filter,
            week: e.target.value,
            startDate: e.target.value !== '' ? week.start : '',
            endDate: e.target.value !== '' ? week.end : '',
            page: 1,
        });
    };

    const handleCommune = (e) => {
        e.preventDefault();
        setFilter({ ...filter, commune: e.target.value, page: 1 });
    };

    return (
        <>
            {/** Filter */}
            <div
                className={`flex-col xl:pt-16 lg:pt-16 pt-10 mx-auto w-full flex justify-center items-center px-4 md:px-0 sm:px-0`}
            >
                <div
                    id="positions-table-mobile"
                    className="mb-7 xl:hidden lg:hidden block item-center cursor-pointer"
                    onClick={(e) => handlerPositions(e)}
                >
                    <Image
                        imgClassName={``}
                        className={`w-full justify-left content-end  rounded-full relative`}
                        src={sport === 'futbol' ? DesafiaIconsFutbol : goToPositions}
                        minWidth={null}
                        key={`img-goToPositions`}
                        alt="Ir a la tabla de posiciones"
                        //width={sport === 'futbol' ? 116 : 116}
                        height={sport === 'futbol' ? 150 : 150}
                    />
                    <div className="flex justify-center items-center text-center mx-auto">
                        <h5
                            className={`w-20 text-white text-[12px] italic font-semibold ${
                                sport === 'futbol' ? 'pt-10' : 'pt-0'
                            } inline absolute`}
                        >
                            IR AL RANKING
                        </h5>
                    </div>
                </div>
                <div className="container snap-mandatory snap-y pt-4">
                    <div
                        className={`grid w-full grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 text-center justify-center items-center`}
                    >
                        {/** Comuna */}
                        <div className="flex-col flex justify-right items-end p-2 md:px-4">
                            <div className="flex w-full md:w-60 h-14 justify-center content-center ">
                                {!loading ? (
                                    <select
                                        className={`${
                                            error.commune
                                                ? 'border-red-600 shadow-error'
                                                : filter?.commune
                                                ? 'border-green-600 shadow-success'
                                                : 'border-sm-gray-3'
                                        } w-full md:w-60 lg:w-60 p-2 h-14 bg-white border-2  rounded-xl text-center`}
                                        name="commune"
                                        value={filter?.commune}
                                        onChange={handleCommune}
                                        disabled={communes && communes.length > 0 ? false : true}
                                    >
                                        <option className="text-sm-gray-1" value="">
                                            Comuna
                                        </option>
                                        {communes &&
                                            communes.length > 0 &&
                                            communes.map((commune) => (
                                                <option value={commune.id} key={`commune-${commune.id}`}>
                                                    {commune.name}
                                                </option>
                                            ))}
                                    </select>
                                ) : (
                                    <div className="border border-sm-rent shadow rounded-xl p-4 max-w-sm w-full mx-auto">
                                        <div className="animate-pulse flex space-x-4">
                                            <div className="rounded-full bg-sm-rent-dark h-6 w-12"></div>
                                            <p className="pl-1 animate-pulse text-sm-rent-dark">Comuna</p>
                                            <div className="flex-1 space-y-4 py-1">
                                                <div className="h-4 bg-sm-rent-dark rounded w-3/4"></div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Semana */}
                        <div className="flex-col flex justify-start  items-start p-2 md:px-4">
                            <div className="flex w-full md:w-60 h-14  justify-center content-center ">
                                <select
                                    className={`${
                                        dateList && filter?.week
                                            ? 'border-green-600 shadow-success'
                                            : 'border-sm-gray-3'
                                    } w-full md:w-60 lg:w-60 p-2 h-14 bg-white border-2  rounded-xl text-center`}
                                    name="week"
                                    value={filter?.week || ''}
                                    onChange={handleWeek}
                                    disabled={dateList && dateList.length > 0 ? false : true}
                                >
                                    <option className="text-sm-gray-1" value="">
                                        Semana
                                    </option>
                                    {dateList &&
                                        dateList.length > 0 &&
                                        dateList.map((d) => (
                                            <option value={d.id} key={d.id}>
                                                {d.label}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    id="positions-table"
                    className="my-5 w-40
                    item-center 
                    xl:-top-[140px] 
                    xl:block
                    xl:relative 
                    xl:-right-[400px]
                    lg:block 
                    lg:relative 
                    lg:-right-[400px] 
                    lg:-top-[140px]
                    hidden
                    cursor-pointer
                    "
                    onClick={(e) => handlerPositions(e)}
                >
                    <div className="absolute">
                        <Image
                            imgClassName={`rounded-3xl ${sport === 'futbol' ? 'pt-4' : 'p-0'}  m-0`}
                            className={``}
                            src={sport === 'futbol' ? DesafiaIconsFutbol : goToPositions}
                            minWidth={null}
                            key={`img-EscudoAzul`}
                            alt="presentation"
                            //width={sport === 'futbol' ? 116 : 120}
                            height={150}
                        />
                        <div
                            className={`flex justify-center items-center text-center mx-auto ${
                                sport === 'futbol' ? 'pt-10' : '-pt-10'
                            }`}
                        >
                            <h5 className="w-20 text-white text-sm italic font-semibold pt-0 inline absolute">
                                IR AL RANKING
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
